import tabsList from '../../../../../vendor/tabsspaces/tabslist/src/assets/tabsList.js';